import React from 'react';
import { FormattedMessage } from 'react-intl';
import featureImg1 from '../Images/land-finding-img1.png';
import featureImg2 from '../Images/land-finding-img2.png';
import featureImg3 from '../Images/land-finding-img3.png';
import css from './Sections.module.css';

function FeatureSection() {
  return (
    <div className={css.featureSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featureInfo}>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg1} alt="" />
            </div>
            <h3>
              <FormattedMessage id="LandFindingPage.FeatureSection.ruralTitle" />
            </h3>
            <p>
              <FormattedMessage id="LandFindingPage.FeatureSection.ruralDescription" />
            </p>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg2} alt="" />
            </div>
            <h3>
              <FormattedMessage id="LandFindingPage.FeatureSection.suburbanTitle" />
            </h3>
            <p>
              <FormattedMessage id="LandFindingPage.FeatureSection.suburbanDescription" />
            </p>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg3} alt="" />
            </div>
            <h3>
              <FormattedMessage id="LandFindingPage.FeatureSection.urbanTitle" />
            </h3>
            <p>
              <FormattedMessage id="LandFindingPage.FeatureSection.urbanDescription" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeatureSection;
